export const ANIMATION_DURATION = 1000;
export const ZOOM_LEVEL = 1;
